// -----------------------------
// 配送希望日（通常ページ側）
// -----------------------------
function activateDatePicker() {
  const $input = $("#date");
  if (!$input.length || $input.data("datepicker")) return;

  $input.datepicker({
    format: "yyyy/mm/dd",
    startDate: "+4d",
    //endDate: "+13d",
    endDate: "+42d",
    language: "ja",
    todayHighlight: true,
    clearBtn: true,
  }).on("changeDate", function () {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { date: $input.val() },
      }),
    });
    $("#date_drawer").val($input.val());
  });

  $input.datepicker("update", $input.data("delivery_date"));
  console.log("📅 activateDatePicker initialized ✅");
}

// -----------------------------
// 配送希望日（ドロアーカート側）
// -----------------------------
function activateDrawerDatePicker() {
  const $drawerInput = $("#date_drawer");
  if (!$drawerInput.length) return;

  // destroyして再初期化
  if ($drawerInput.data("datepicker")) {
    $drawerInput.datepicker("destroy");
  }

  $drawerInput.datepicker({
    format: "yyyy/mm/dd",
    startDate: "+4d",
    endDate: "+13d",
    language: "ja",
    todayHighlight: true,
    clearBtn: true,
  }).on("changeDate", function () {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { date: $drawerInput.val() },
      }),
    });
    $("#date").val($drawerInput.val());
  });

  $drawerInput.datepicker("update", $drawerInput.data("delivery_date"));

  // ✅ Chrome対策：readonlyでも開く
  $drawerInput.on("click focus", function () {
    $(this).datepicker("show");
  });

  console.log("📅 activateDrawerDatePicker initialized ✅");
}

// -----------------------------
// ページ読み込み後の初期化
// -----------------------------
$(document).ready(function () {
  // 通常ページ
  activateDatePicker();
  activateDrawerDatePicker();

  // --- ドロアー内の変化（商品追加・削除）を監視 ---
  const drawer = document.getElementById("CartDrawer");
  if (drawer) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        // 新しいinput#date_drawerが出現したら再初期化
        if (
          mutation.addedNodes.length > 0 &&
          document.getElementById("date_drawer")
        ) {
          console.log("👀 Drawer content changed — reinitializing datepicker…");
          setTimeout(activateDrawerDatePicker, 200);
          break;
        }
      }
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  // --- 折りたたみクリックで再初期化 ---
  document.addEventListener("click", (e) => {
    if (e.target.closest(".collapsible-trigger")) {
      setTimeout(activateDrawerDatePicker, 300);
    }
  });
});